!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.localizify = t() : e.localizify = t();
}("undefined" != typeof window ? window : this, function () {
  return function (n) {
    var r = {};
    function o(e) {
      if (r[e]) return r[e].exports;
      var t = r[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
    }
    return o.m = n, o.c = r, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (t, e) {
      if (1 & e && (t = o(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
        return t[e];
      }.bind(null, r));
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 0);
  }([function (e, t, n) {
    e.exports = n(1);
  }, function (i, e, t) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function a(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function u(e, t) {
      return !t || "object" !== n(t) && "function" != typeof t ? function (e) {
        if (void 0 !== e) return e;
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }(e) : t;
    }
    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function l(e, t) {
      return (l = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    var c = t(2),
      f = t(3),
      p = "CHANGE_LOCALE",
      y = "TRANSLATION_NOT_FOUND",
      h = "REPLACED_DATA_NOT_FOUND",
      r = function (e) {
        function t() {
          var e;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (e = u(this, s(t).call(this)))._store = {
            locale: "en",
            localesList: ["en"],
            scope: null,
            translations: {},
            interpolations: {},
            normalizedKeys: {},
            separator: "."
          }, e;
        }
        var n, r, o;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && l(e, t);
        }(t, c), n = t, (r = [{
          key: "getStore",
          value: function value() {
            return this._store;
          }
        }, {
          key: "getLocale",
          value: function value() {
            return this.getStore().locale;
          }
        }, {
          key: "setLocale",
          value: function value(e) {
            var t = this.getStore().locale;
            return this.isLocale(e) && t !== e && (this.getStore().locale = e, this.emit(p, e, t)), this;
          }
        }, {
          key: "isLocale",
          value: function value(e) {
            return this.getStore().localesList.includes(e);
          }
        }, {
          key: "onLocaleChange",
          value: function value(e) {
            return this.on(p, e), e;
          }
        }, {
          key: "onTranslationNotFound",
          value: function value(e) {
            this.on(y, e);
          }
        }, {
          key: "onReplacedDataNotFound",
          value: function value(e) {
            this.on(h, e);
          }
        }, {
          key: "setDefaultScope",
          value: function value(e) {
            return this.getStore().scope = e, this;
          }
        }, {
          key: "clearDefaultScope",
          value: function value() {
            return this.getStore().scope = null, this;
          }
        }, {
          key: "registerInterpolations",
          value: function value(e) {
            return Object.assign(this.getStore().interpolations, e), this;
          }
        }, {
          key: "add",
          value: function value(e, t) {
            var n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
              r = this.getStore(),
              o = t;
            return n && ((o = {})[t] = n), this.isLocale(e) || r.localesList.push(e), r.translations[e] = Object.assign({}, r.translations[e], o), r.normalizedKeys[e] = Object.assign({}, r.normalizedKeys[e], f(o)), this;
          }
        }, {
          key: "_isBrowser",
          value: function value() {
            return !i.exports || "undefined" != typeof navigator;
          }
        }, {
          key: "detectLocale",
          value: function value() {
            var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];
            if (this._isBrowser() && !e && (e = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage), !e) return !1;
            var t = e.toLowerCase().split(/[_-]+/)[0];
            return !!this.isLocale(t) && t;
          }
        }, {
          key: "_replaceData",
          value: function value(r, o) {
            var i = this,
              a = r;
            return (a.match(/\{(.*?)\}/gi) || []).forEach(function (e) {
              var t = e.replace(/[{}]/gi, ""),
                n = [o[t], i.getStore().interpolations[t], e].find(function (e) {
                  return void 0 !== e;
                });
              n === e && i.emit(h, r, e, o), a = a.replace(e, n);
            }), a;
          }
        }, {
          key: "translate",
          value: function value(e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
            if (!e) throw new Error('"key" param is required');
            var n = t.scope || this.getStore().scope,
              r = this.isLocale(t.locale) && t.locale || this.getStore().locale;
            if (!r) throw new Error("Current locale is not defined");
            var o = this.getStore().normalizedKeys[r],
              i = (n ? "".concat(n, ".") : "") + e,
              a = o && o[i];
            return a || this.emit(y, r, e, n), this._replaceData(a ? o[i] : e, t);
          }
        }]) && a(n.prototype, r), o && a(n, o), t;
      }(),
      o = new r();
    o.Instance = r, o.t = o.translate.bind(o), i.exports = o;
  }, function (e, t) {
    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    var n = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._listeners = {};
      }
      var t, n, r;
      return t = e, (n = [{
        key: "getListeners",
        value: function value(e) {
          return this._listeners[e] || [];
        }
      }, {
        key: "on",
        value: function value(e, t) {
          if ("function" != typeof t) throw new TypeError("Listener must be a function");
          return this.getListeners(e).includes(t) || (this.hasListeners(e) || (this._listeners[e] = []), this._listeners[e].push(t)), t;
        }
      }, {
        key: "off",
        value: function value(e, t) {
          if (this.hasListeners(e)) {
            var n = this.getListeners(e);
            this._listeners[e] = n.filter(function (e) {
              return t !== e;
            });
          }
          return this;
        }
      }, {
        key: "emit",
        value: function value(e) {
          for (var t = this, n = arguments.length, r = new Array(1 < n ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
          return this.getListeners(e).forEach(function (e) {
            return e.apply(t, r);
          }), this;
        }
      }, {
        key: "hasListeners",
        value: function value(e) {
          return 0 < this.getListeners(e).length;
        }
      }]) && o(t.prototype, n), r && o(t, r), e;
    }();
    e.exports = n;
  }, function (e, t) {
    function i(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    e.exports = function t(n) {
      var e,
        r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
        o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
      return "string" == typeof n ? o[r.join(".")] = n : null !== (e = n) && "[object Object]" === Object.prototype.toString.call(e) && Object.keys(n).forEach(function (e) {
        return t(n[e], i(r).concat([e]), o);
      }), o;
    };
  }]);
});